import React from 'react';
import { Box } from '@mui/material';

const VideoBanner = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '140vh',
        overflow: 'hidden',
        marginTop: '-20vh',
      }}
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        
        style={{
          opacity: 0.5,
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          top: '52%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <source src="banner.mp4" type="video/mp4" />
      </video>

      {/* Optional overlay for better text readability */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.3)', // Adjust opacity as needed
          zIndex: 1,
        }}
      />

      {/* Optional content overlay */}
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
        }}
      >
        {/* Add your content here */}
      </Box>
    </Box>
  );
};

export default VideoBanner; 
